export default __webpack_public_path__ + "cover.86b1db55.jpg";